import { resolve } from "../i18n/catalogs";
import { interpolate } from "../i18n/interpolate";

// UI chrome is audience-neutral English in Phase 1: ui.* keys live only in en/family,
// so resolving under en/family serves both audiences (professional falls back to family).
const UI_CONTEXT = { locale: "en", audience: "family" as const };

export function t(key: string, vars?: Record<string, string | number>): string {
  const s = resolve(key, UI_CONTEXT);
  return vars ? interpolate(s, vars) : s;
}
